import React, { useContext, useState } from 'react'
import SearchBox from "components/Common/SearchBox"
import { connect } from 'react-redux'
import { Link, useParams } from 'react-router-dom'
import { Card, CardBody } from 'reactstrap'
import { store as socketStore } from 'components/Common/Socket/store'
import * as actions from '../../../actions'
import { EVENT_DETAILS_READ_MODE_ANNOUNCEMENTS } from '../../../eventDetailsReadPolicy'
import AnnouncementCard from './AnnouncementCard'
import { announcementActive, readAnnouncementContent } from './announcementContent'
import { sortAnnouncementsForDisplay } from './announcementDisplay'
import { anyPending, useTranslationRefresh } from 'components/Common/localizedText'
import './announcements.scss'
export { AnnouncementActionsMenu } from './AnnouncementActions'

export const Announcement = ({ events, getEventDetails, refreshEventAnnouncements }) => {
  const { eventDetails = [], error = '' } = events
  const { eventId } = useParams()
  const event = eventDetails[0] || {}
  const { state: { socket: { socketClientId } = {} } = {} } = useContext(socketStore)
  const [search, setSearch] = useState('')
  const [status, setStatus] = useState('ALL')
  const available = Array.isArray(event.announcements)
  const query = search.trim().toLocaleLowerCase()
  const filtered = sortAnnouncementsForDisplay(event.announcements).filter(announcement => {
    if (status === 'ACTIVE' && !announcementActive(announcement)) return false
    if (status === 'DISABLED' && announcement.status !== 'DISABLED') return false
    return !query || (announcement.title + ' ' + readAnnouncementContent(announcement.message).text).toLocaleLowerCase().includes(query)
  })
  const retry = () => getEventDetails(event._id || eventId, EVENT_DETAILS_READ_MODE_ANNOUNCEMENTS)
  // While an announcement's text translates (ADR 0013), the announcements read again until its marker settles; a read that fails keeps them.
  const translating = available && event.announcements.some(announcement => anyPending(announcement.localizedTexts))
  useTranslationRefresh(translating, () => refreshEventAnnouncements?.(event._id), event._id)
  return <Card className="mt-2"><CardBody className="announcements-page">
    <div className="announcement-heading"><h2>Announcements</h2>{event._id && <Link className="btn btn-success" to={'/add-announcement/' + event._id}>+ Add Announcement</Link>}</div>
    {error && <div className="alert alert-danger" role="alert"><p>Could not load announcements.</p><button className="btn btn-outline-danger" type="button" onClick={retry}>Retry</button></div>}
    {!available && !error ? <p>Loading announcements...</p> : available && <>
      <div className="announcement-filters">
        <label htmlFor="announcement-search">Search announcements<SearchBox id="announcement-search" value={search} onValueChange={setSearch} placeholder="Title or message" /></label>
        <label htmlFor="announcement-status">Status<select id="announcement-status" className="form-control" value={status} onChange={e => setStatus(e.target.value)}><option value="ALL">All</option><option value="ACTIVE">Active</option><option value="DISABLED">Disabled</option></select></label>
      </div>
      <p className="text-muted" aria-live="polite">{filtered.length} of {event.announcements.length} announcements</p>
      {!event.announcements.length ? <p>No announcements yet</p> : !filtered.length ? <p>No announcements match these filters.</p> : filtered.map(announcement => <AnnouncementCard key={announcement._id} announcement={announcement} event={event} getEventDetails={getEventDetails} socketClientId={socketClientId} />)}
    </>}
  </CardBody></Card>
}
export default connect(({ events }) => ({ events }), { getEventDetails: actions.getEventDetails,
  refreshEventAnnouncements: actions.refreshEventAnnouncements })(Announcement)
